import React, { useState } from 'react';
import { api, errText, storeSession } from '../api.js';
import Icon from '../Icon.jsx';

export default function AdminLogin({ onDone }) {
  const [form, setForm] = useState({});
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  async function go() {
    setErr(''); setBusy(true);
    try {
      const data = await api('/api/admin/login', { method: 'POST', body: form, retry: false });
      storeSession({ accessToken: data.accessToken, refreshToken: data.refreshToken, kind: 'platform' });
      onDone(data);
    } catch (e) {
      setErr(errText(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center">
      <div className="login">
        <h1 style={{ fontSize: 22, marginBottom: 4 }}>OrderCEO</h1>
        <p className="muted" style={{ marginTop: 0 }}>Süper admin</p>
        <div className="card">
          <label>E-posta</label>
          <input value={form.email || ''} onChange={set('email')} />
          <label style={{ marginTop: 8 }}>Şifre</label>
          <input type="password" value={form.password || ''} onChange={set('password')} onKeyDown={(e) => e.key === 'Enter' && go()} />
          <button className="primary" style={{ marginTop: 12, width: '100%' }} disabled={busy} onClick={go}><Icon n="login" />Giriş</button>
          {err && <p className="err" style={{ marginBottom: 0 }}>{err}</p>}
        </div>
        <p className="muted" style={{ textAlign: 'center' }}><a href="/">Restoran girişi</a></p>
      </div>
    </div>
  );
}
